import React, { useEffect, useState } from "react";
import { Constants } from "@eagerdog/constants";
import { IEvent } from "@eagerdog/interfaces";

import Input from "src/components/Input/Input";
import Button from "src/components/Button/Button";
import { toast } from "src/components/Toast/ToastManager";

import styles from "./index.module.scss";

interface IProps {
  event: IEvent,
  onSubmit: (judgeName: string, judgeNumber: string) => void,
  title?: string,
  submitLabel?: string,
  initialName?: string,
  initialNumber?: string
}

const AddRunningOrderJudge = ({
  event,
  onSubmit,
  title = "Add Judge",
  submitLabel = "Save",
  initialName = "",
  initialNumber = "",
}: IProps) => {
  const [name, setName] = useState<string>(initialName);
  const [number, setNumber] = useState<string>(initialNumber);

  useEffect(() => {
    setName(initialName);
    setNumber(initialNumber);
  }, [initialName, initialNumber]);

  // For PWDCA, C-Wags, and GENERAL, judge_number is optional
  const isJudgeNumberOptional = event.sanctioning_club === Constants.sanctioning_club.PWDCA || 
                                event.sanctioning_club === Constants.sanctioning_club.C_WAGS ||
                                event.sanctioning_club === Constants.sanctioning_club.GENERAL;

  const handleSubmit = () => {
    if (!name) {
      toast.show({
        title: "Add Judge",
        content: "Please enter judge's name",
        duration: 10000,
        type: "fail",
      });
      return;
    }

    if (!isJudgeNumberOptional && !number) {
      toast.show({
        title: "Add Judge",
        content: "Please enter judge's name and number",
        duration: 10000,
        type: "fail",
      });
      return;
    }

    onSubmit(name, number);
  }

  return (
    <div className={styles.AddRunningOrderJudge}>
      <div className={styles.title}>
        {title}
      </div>
      <div className={styles.inputs}>
        <Input
          required
          className={styles.name}
          defaultValue={name}
          label="Judge name"
          placeholder="Please enter judge name"
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <Input
          required={!isJudgeNumberOptional}
          className={styles.number}
          defaultValue={number}
          label={"Judge #" + (isJudgeNumberOptional ? " (optional)" : "")}
          placeholder="Please enter judge number"
          onChange={(e) => {
            setNumber(e.target.value);
          }}
        />
      </div>
      <Button className={styles.submit} type="submit" onClick={handleSubmit}>{submitLabel}</Button>
    </div>
  );
}

export { AddRunningOrderJudge }
